export const SITE_NAME = 'Rentasvet';
export const SITE_URL = 'https://rentasvet.rs';

/**
 * Build a BreadcrumbList JSON-LD object.
 * Usage: breadcrumbJsonLd({ name: 'Početna', url: '/' }, { name: 'Vozila', url: '/products/vozila' })
 */
export const breadcrumbJsonLd = (...items) => ({
  '@context': 'https://schema.org',
  '@type': 'BreadcrumbList',
  itemListElement: items.map((item, index) => ({
    '@type': 'ListItem',
    position: index + 1,
    name: item.name,
    item: item.url ? `${SITE_URL}${item.url}` : SITE_URL,
  })),
});
